import PropTypes from 'prop-types';
import { SET_APP_DATA, SET_APP_USER, LOG_OUT_USER, UPDATE_USER_COUNTS, APP_HEARTBEAT } from './App.actions';
import { SW_NEW_CONTENT } from '../../registerServiceWorker';
import update from 'immutability-helper';
import PortalApi from '../../services/PortalApi';
import { clearUnread } from '../../services/Post';
import { gtmPush } from '../../components/GoogleTagManager';

export const propTypes = {
	user: PropTypes.object,
	assets: PropTypes.object,
	ping: PropTypes.bool,
	newContentAvailable: PropTypes.bool,
};

export const defaultProps = {
	user: null,
	assets: null,
};

export const mapStateToProps = {
	app: ( state, action ) => {
		switch ( action.type ) {
			case SET_APP_DATA:
				return {
					...state,
					assets: action.assets,
					ping: action.ping
				};
			case SET_APP_USER:
				// There was a request that all users be able to see all services in the filters, but still only see posts
				// for the divisions they belong to.  Setting access_tags here will include all services in the various
				// filters, but does change their actual access, so posts still need to be tagged with their division in
				// order to show up.
				if ( action.user && action.user.access_tags ) {
					action.user.access_tags.service = action.user.tags.service;
				}
				if ( action.user && ! action.user.isGuest ) {
					gtmPush({
						userId: action.user.analytics_token
					});
				} else {
					gtmPush({
						userId: null
					});
				}
				return {
					...state,
					user: action.user,
				};
			case LOG_OUT_USER:
				gtmPush({
					userId: null
				});
				return {
					...state,
					user: { isGuest: true },
				};
			case UPDATE_USER_COUNTS:
				return {
					...state,
					user: update(state.user, {counts: { $merge: action.counts} })
				};
			case APP_HEARTBEAT:
				return {
					...state,
					ping: action.ping
				};
			case SW_NEW_CONTENT:
				return {
					...state,
					newContentAvailable: !action.clear,
				};
			default:
				return state;
		}
	}
};

export const mapDispatchToProps = {
	doLogout: () => {
		return (dispatch) => {
			dispatch({
				type: LOG_OUT_USER,
			});
			PortalApi.postLogout();
		}
	},
	onClearUnread: (post_types) => {
		return dispatch => {
			clearUnread( post_types );
		}
	}
};




// WEBPACK FOOTER //
// ./src/containers/App/App.props.js